import { all, takeLatest } from 'redux-saga/effects';
import {
  CREATE_PROGRAM,
  GET_PROGRAMS,
  GET_PROGRAM_DETAILS,
  GET_PROGRAM_INFO,
  GET_PROGRAM_STATUS,
  GET_TOP_PROGRAMS,
  REVIEW_PROGRAM,
} from '../../actions/programs';
import {
  createProgramSaga,
  getAllProgramsSaga,
  getProgramDetailsSaga,
  getProgramInfoSaga,
  getProgramStatusSaga,
  getTopProgramsSaga,
  reviewProgramSaga,
} from './getProgramsSaga';

function* programSagas() {
  yield all([
    yield takeLatest(GET_PROGRAMS.INITIATE, getAllProgramsSaga),
    yield takeLatest(REVIEW_PROGRAM.INITIATE, reviewProgramSaga),
    yield takeLatest(GET_TOP_PROGRAMS.INITIATE, getTopProgramsSaga),
    yield takeLatest(CREATE_PROGRAM.INITIATE, createProgramSaga),
    yield takeLatest(GET_PROGRAM_INFO.INITIATE, getProgramInfoSaga),
    yield takeLatest(GET_PROGRAM_DETAILS.INITIATE, getProgramDetailsSaga),
    yield takeLatest(GET_PROGRAM_STATUS.INITIATE, getProgramStatusSaga),
  ]);
}

export default programSagas;
